<template>
  <div id="applicant-create">
    <div class="vx-row">
      <div class="vx-col w-full" :class="{ 'lg:w-1/2': emailRegistration }">
        <vx-card>
          <div slot="no-body" class="p-6">
            <form-wizard
              color="rgba(var(--vs-primary), 1)"
              error-color="rgba(var(--vs-danger), 1)"
              :title="null"
              :subtitle="null"
              next-button-text="Weiter"
              back-button-text="Zurück"
              finish-button-text="Erstellen"
              @on-complete="submit"
              @submit.prevent
            >
              <tab-content
                title="Persönliche Daten"
                class="mb-5"
                icon="fas fa-user"
                :before-change="validateStep1"
              >
                <ValidationObserver ref="stepOne" tag="form" @submit.prevent>
                  <div class="mb-4">
                    <div class="vx-row mt-5 mb-10">
                      <div class="vx-col">
                        <vs-checkbox
                          v-model="wantedSteps.application"
                          icon="fa-check"
                          icon-pack="fas"
                          >Bewerbung erfassen</vs-checkbox
                        >
                      </div>
                      <!-- <div class="vx-col">
                    <vs-checkbox
                      v-model="wantedSteps.cv"
                      icon="fa-check"
                      icon-pack="fas"
                      >Lebenslauf erfassen</vs-checkbox
                    >
                  </div> -->
                      <div class="vx-col">
                        <vs-checkbox
                          v-model="wantedSteps.internal"
                          icon="fa-check"
                          icon-pack="fas"
                          >Interne Daten erfassen</vs-checkbox
                        >
                      </div>
                      <div class="vx-col">
                        <vs-checkbox
                          v-model="wantedSteps.profile"
                          icon="fa-check"
                          icon-pack="fas"
                          >Profil erfassen</vs-checkbox
                        >
                      </div>
                    </div>
                  </div>
                  <PersonalData
                    ref="personalData"
                    v-model="applicant"
                    email-duplicate-check
                  />
                </ValidationObserver>
              </tab-content>

              <tab-content
                v-if="wantedSteps.application"
                title="Bewerbung"
                class="mb-5"
                icon="fal fa-user-astronaut"
                :before-change="validateStep2"
              >
                <ValidationObserver ref="stepTwo" tag="form" @submit.prevent>
                  <ApplicationAs v-model="applicant.profile" />
                </ValidationObserver>
              </tab-content>

              <tab-content
                v-if="wantedSteps.internal"
                title="Intern"
                class="mb-5"
                icon="far fa-unlock"
                :before-change="validateStep4"
              >
                <ValidationObserver ref="stepFour" tag="form" @submit.prevent>
                  <InternalData
                    v-model="applicant"
                    :profile="applicant.profile"
                  />
                </ValidationObserver>
              </tab-content>

              <tab-content
                v-if="wantedSteps.profile"
                title="Profil"
                class="mb-5"
                icon="far fa-user-unlock"
                :before-change="validateStep5"
              >
                <ValidationObserver ref="stepFive" tag="form" @submit.prevent>
                  <InternalProfile
                    v-model="applicant.profile"
                    :hide-rating="wantedSteps.internal"
                  />
                </ValidationObserver>
              </tab-content>
            </form-wizard>
          </div>
        </vx-card>
      </div>
      <div
        v-if="emailRegistration"
        id="applicant-create-mail"
        class="vx-col w-full lg:w-1/2"
      >
        <!-- <div >{{ emailRegistration }}</div> -->
        <vx-card>
          <div slot="no-body" class="p-6">
            <EmailPreviewCreate
              :email-id="emailRegistration.id"
            ></EmailPreviewCreate>
            <div v-if="emailRegistration.pitchYouData">
              <span v-if="pitchYouImported">PitchYou Daten importiert</span>
              <vs-button
                v-else
                class="btn btn-primary"
                @click="insertPitchyouData"
                >PitchYou Daten Importieren</vs-button
              >
              <pre
                v-if="
                  emailRegistration.pitchYouData &&
                    emailRegistration.pitchYouData.errors
                "
              ></pre>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import gql from "graphql-tag";
import ApplicationAs from "../form/ApplicationAs";
// import CV from "../form/CV";
import InternalData from "../form/InternalData";
import InternalProfile from "../form/InternalProfile";
import PersonalData from "../form/PersonalData";
import EmailPreviewCreate from "../../../components/applicant/EmailPreviewCreate.vue";
import salutations from "@/data/enums/Salutation.js";

/* eslint-disable no-unused-vars */
const pitchYouFieldMap = {
  name(applicant, value, _, update) {
    let parts = [];
    parts = value.split(" ");
    update("firstName", parts[0]);
    update("lastName", parts.slice(1).join(" "));
  },
  telephone: "contactData.telephone",
  streetAddress(applicant, address, _, update) {
    let parts = address.split(" ");
    if (parts.length !== 2) return;
    let addrObj = applicant.contactData.address || {};
    addrObj.zip = parts[0];
    addrObj.city = parts[1];
    update("contactData", addrObj, "address");
  },
  email: "contactData.email",
  group(_, group, apollo, update) {
    return apollo
      .query({
        query: gql`
          query UserGroups($search: String) {
            userGroups(page: 1, search: $search) {
              results {
                id
              }
            }
          }
        `,
        variables: {
          search: group
        },
        fetchPolicy: "no-cache"
      })
      .then(({ data }) => data.userGroups.results[0].id)
      .then(id => update("userGroupID", id))
      .catch(console.log);
  },
  privacyPolicyAccepted(applicant, privacyPolicyAccepted) {
    applicant.privacyPolicyAccepted = !!privacyPolicyAccepted;
  },
  salutation(_, salutation, __, update) {
    console.log(salutation);
    update(
      "salutation",
      (Object.entries(salutations).find(e => e[1] == salutation) || [])[0]
    );
  },
  birthDate: "birthday",
  availableFrom: "profile.availabilityCustom",
  mobility: "profile.mobilityCustom",
  hasDriversLicense(applicant, group, apollo) {
    //TODO: get drivers license for cars
  },
  hasCar: "profile.ownCar",
  hasForkliftLicense(applicant, group, apollo) {
    //TODO:// get drivers license for forklift
  }
  ///TODO: assign skill fields
};
/* eslint-enable no-unused-vars */

export default {
  components: {
    FormWizard,
    TabContent,
    ApplicationAs,
    // CV,
    InternalData,
    InternalProfile,
    PersonalData,
    EmailPreviewCreate
  },
  data: () => ({
    pitchYouImported: false,
    showPreview: true,
    applicant: {
      contactData: {
        telephone: undefined,
        telephoneMobile: undefined,
        address: undefined,
        email: undefined
      },
      contactDataCompany: {
        telephone: undefined,
        telephoneMobile: undefined,
        email: undefined
      },
      profile: {},
      salutation: undefined,
      title: undefined,
      salutationType: undefined,
      firstName: undefined,
      lastName: undefined,
      birthday: undefined,
      birthplace: undefined,
      civilStatus: undefined,
      kids: undefined,
      nationality: undefined,
      residentPermit: undefined,
      source: undefined,
      wantsNewsletter: undefined
    },
    createUser: false,
    sendUserData: true,
    wantedSteps: {
      profile: true,
      application: true,
      // cv: true,
      internal: true
    },
    submitted: false,
    covidVaccination: {
      state: undefined,
      lastVaccinationForCompleteCoverage: undefined,
      lastPCRTestDateForRecovery: undefined
    }
  }),
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
            consultant {
              id
            }
          }
        }
      `,
      result(r) {
        if (r.data.me.consultant) {
          this.applicant.profile.internalConsultantID = r.data.me.consultant.id;
          this.applicant.profile.consultantID = r.data.me.consultant.id;
        }
      }
    },
    emailRegistration: {
      query: gql`
        query GetMailRegistrationById($id: Int!) {
          getMailRegistrationById(id: $id) {
            id
            content
            attachments {
              mimeType
              name
              emailId
            }
            subject
            pitchYouData {
              id
              name
              telephone
              email
              streetAddress
              source
              group
              privacyPolicyAccepted
              salutation
              birthDate
              schoolDiploma
              jobExperience
              jobExperienceText
              previousJobTasks
              hasCv
              hasAdditionalQuestion
              additionalQuestionText
              completedVocationalTraining
              availableFrom
              mobility
              shiftWork
              trainingText
              currentlyEmployed
              knowledgeText
              hasDriversLicense
              hasCar
              currentJobTasks
              hasForkliftLicense
              immidiatelyAvailable
              foreignCitizenship
              canWeld
              weldingKnowledgeText
              cancellationNoticeText
              canWorkWithCircuitDiagrams
              parsedFields
              errors
            }
          }
        }
      `,
      variables() {
        return {
          id: parseInt(this.$route.query.transfermail)
        };
      },
      update: data => {
        if (data.getMailRegistrationById.pitchYouData) {
          let newData = {};
          for (const field of data.getMailRegistrationById.pitchYouData
            .parsedFields) {
            newData[field] = data.getMailRegistrationById.pitchYouData[field];
          }
          newData.errors = data.getMailRegistrationById.pitchYouData.errors;
          data.getMailRegistrationById.pitchYouData = newData;
        }
        return data.getMailRegistrationById;
      }
    }
  },
  mounted() {
    if (this.$route.query) {
      for (let param of Object.keys(this.$route.query)) {
        let paramParts = param.split(".");
        let paramValue = this.$route.query[param];

        if (paramParts[0] === "applicant") {
          this.applicant[paramParts[1]] = paramValue;
        }
      }
    }
  },
  methods: {
    setField(mapping, value) {
      let ob = this.applicant;
      let parts = mapping.split(".");

      if (parts.length == 2) {
        this.$refs.personalData.updateValue(parts[0], value, parts[1]);
        return;
      } else if (parts.length == 2) {
        this.$refs.personalData.updateValue(parts[0], value);
        return;
      }
      while (parts.length > 1) {
        let current = parts.shift();
        if (!ob[current]) {
          ob[current] = {};
        }
        ob = ob[current];
      }
      ob[parts[0]] = value;
    },
    insertPitchyouData() {
      let promises = [];
      for (const [field, value] of Object.entries(
        this.emailRegistration.pitchYouData || {}
      )) {
        console.log("here");
        const mapping = pitchYouFieldMap[field];
        if (field !== "errors" && mapping) {
          if (typeof pitchYouFieldMap[field] == "string") {
            this.setField(mapping, value);
          } else {
            promises.push(
              mapping(
                this.applicant,
                value,
                this.$apollo,
                this.$refs.personalData.updateValue
              )
            );
          }
        }
      }
      this.applicant.source = "29ffc33c-a912-11ec-8403-901b0ebdf486";
      Promise.all(promises).then((this.pitchYouImported = true));
    },
    async validateStep1() {
      return await this.$refs.stepOne.validate();
    },
    async validateStep2() {
      return await this.$refs.stepTwo.validate();
    },
    // async validateStep3() {
    //   return await this.$refs.stepThree.validate();
    // },
    async validateStep4() {
      return await this.$refs.stepFour.validate();
    },
    async validateStep5() {
      return await this.$refs.stepFive.validate();
    },
    async submit() {
      if (
        this.applicant.covidVaccination &&
        !this.applicant.covidVaccination.state
      ) {
        this.applicant.covidVaccination = null;
      } else if (this.applicant.covidVaccination) {
        if (
          !this.applicant.covidVaccination.lastVaccinationForCompleteCoverage
        ) {
          this.applicant.covidVaccination.lastVaccinationForCompleteCoverage = null;
        }
        if (!this.applicant.covidVaccination.lastPCRTestDateForRecovery) {
          this.applicant.covidVaccination.lastPCRTestDateForRecovery = null;
        }
      }
      if (!this.emailRegistration) {
        if (this.submitted == false) {
          this.submitted = true;
          let { data } = await this.$apollo.mutate({
            mutation: gql`
              mutation($input: CreateApplicantInput!) {
                createApplicant(input: $input) {
                  id
                }
              }
            `,
            variables: {
              input: {
                ...this.applicant
              }
            }
          });

          if (data.createApplicant.id) {
            if (this.$route.query && this.$route.query.transfermail) {
              this.$apollo.mutate({
                mutation: gql`
                  mutation($id: Int!, $applicant: ID!) {
                    transferApplicantMailRegistration(
                      id: $id
                      applicant: $applicant
                    )
                  }
                `,
                variables: {
                  id: this.$route.query.transfermail,
                  applicant: data.createApplicant.id
                }
              });
            }
            this.$router.push({
              name: "applicant.show",
              params: { id: data.createApplicant.id }
            });
          }
        }
      } else {
        let { data } = await this.$apollo.mutate({
          mutation: gql`
            mutation($input: CreateApplicantInput!) {
              createApplicant(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              ...this.applicant
            }
          }
        });

        if (data.createApplicant.id) {
          if (this.$route.query && this.$route.query.transfermail) {
            this.$apollo.mutate({
              mutation: gql`
                mutation($id: Int!, $applicant: ID!) {
                  transferApplicantMailRegistration(
                    id: $id
                    applicant: $applicant
                  )
                }
              `,
              variables: {
                id: this.$route.query.transfermail,
                applicant: data.createApplicant.id
              }
            });
          }
          this.$router.push({
            name: "applicant.show",
            params: { id: data.createApplicant.id }
          });
        }
      }
    }
  }
};
</script>
